import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../../contexts/PermissionContext';
import { getFirstCompanyFromRoles } from '../../utils/roleUtils';

const RedirectToFirstRole: React.FC = () => {
  const { roles, isLoading } = usePermissions();

  // Show loading state while permissions are being loaded
  if (isLoading) {
    return null; // or a loading spinner
  }

  // Debug logging to track redirection
  console.log('🔄 RedirectToFirstRole:', { roles, isLoading });

  // Get the first company from roles
  const firstCompany = getFirstCompanyFromRoles(roles);
  
  if (firstCompany) {
    console.log(`🎯 Redirecting to /games/${firstCompany}`);
    return <Navigate to={`/games/${firstCompany}`} replace />;
  }

  // Fallback - should rarely happen with proper auth
  console.error('❌ No valid company found from roles, this should not happen with proper authentication');
  return <Navigate to="/games/unknown" replace />;
};

export default RedirectToFirstRole;
